import { render, staticRenderFns } from "./BuldingManagementArticles.vue?vue&type=template&id=79ea9ed6"
import script from "./BuldingManagementArticles.vue?vue&type=script&lang=js"
export * from "./BuldingManagementArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports